import React, { FC } from 'react'
import ClientsListContainer from 'containers/ClientsList'

const ClientsListPage: FC = () => <ClientsListContainer />

export default ClientsListPage
